export enum TriggerTypes {
    ASSERTION = "assertion",
    USER_INPUT = "userInput",
    ACQUIRED_DATA = "acquiredData",
    COMPONENT = "component"
}